import template from './hamburger.html';
import controller from './hamburger.controller';
import './hamburger.scss';

let hamburgerComponent = {
  restrict: 'E',
  bindings: {
    open: '<',
    toggle: '&'
  },
  template,
  controller
};

export default hamburgerComponent;
